import { i18n } from '@/plugins/i18n'

export default [
  {
    path: '/categories',
    name: 'categories.index',
    component: () => import('@/views/Categories/Pages/CategoriesIndexPage.vue'),
    meta: {
      layout: 'content',
      auth: true,
      title: i18n.t('Categories overview'),
    },
  },
]
